export const USER_AUTH = 'USER_AUTH'